import { registerModule } from "../module.register";
import { SuperAdminProvider } from "./providers/SuperAdminProvider";
import { superAdminRoutes } from "./super-admin.routes";

registerModule(() => ({
  name: "super-admin",
  component: SuperAdminProvider,
  routes: superAdminRoutes,
  dependencies: ["auth"],
}));
